/**
 * BrewNectar Product Comparison — fade-up + CTA smooth scroll
 */
(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initFadeUp(root) {
    var animated = root.querySelectorAll('.bn-pcmp__animate');

    if (
      prefersReducedMotion() ||
      !('IntersectionObserver' in window) ||
      (typeof Shopify !== 'undefined' && Shopify.designMode)
    ) {
      animated.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var rootMargin = root.getAttribute('data-bn-pcmp-observer-margin') || '-60px 0px';
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: rootMargin, threshold: 0 }
    );

    animated.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initCtaSmoothScroll(root) {
    var cta = root.querySelector('[data-bn-pcmp-cta]');
    if (!cta) return;

    cta.addEventListener('click', function (event) {
      var href = cta.getAttribute('href');
      if (!href || href.charAt(0) !== '#') return;

      var target = document.getElementById(href.slice(1));
      if (!target) return;

      event.preventDefault();
      if (window.BrewNectarScroll) {
        window.BrewNectarScroll.scrollToElement(target);
      } else {
        target.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
      }
    });
  }

  function initRoot(root) {
    if (!root || root.dataset.bnPcmpInit === 'true') return;
    root.dataset.bnPcmpInit = 'true';

    if (root.classList.contains('bn-pcmp--static')) {
      root.querySelectorAll('.bn-pcmp__animate').forEach(function (el) {
        el.classList.add('is-visible');
      });
    } else {
      initFadeUp(root);
    }

    initCtaSmoothScroll(root);
  }

  function initAll() {
    document.querySelectorAll('.bn-pcmp').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.bn-pcmp');
    if (root) {
      delete root.dataset.bnPcmpInit;
      initRoot(root);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('.bn-pcmp');
    if (root) delete root.dataset.bnPcmpInit;
  });
})();
